export default "__VITE_ASSET__BnFC2g1F__"